"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Instagram, Linkedin, Mail, MessageCircle, Twitter } from "lucide-react";
const services = [{
  name: "DICE COMMAND",
  path: "/ShopPage"
}, {
  name: "PATHWAYS: POWER STRIKE",
  path: "/ShopPage"
}, {
  name: "RETAILER PORTAL",
  path: "/ContactPage"
}, {
  name: "DESIGN NOTES",
  path: "/TheArcadePage"
}];
const legalLinks = [{
  name: "Privacy Policy",
  path: "/PrivacyPolicy"
}, {
  name: "Terms of Service",
  path: "/TermsOfService"
}, {
  name: "Cookie Policy",
  path: "/CookiePolicy"
}];
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "X (Twitter)"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-foreground/80 hover:text-primary transition-colors font-sans uppercase text-sm tracking-wide">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="230277" id="final-credits-footer" className="bg-background text-foreground border-t border-border pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-12 mb-16">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="inline-block mb-6">
              <img src="/img/analog_arcade_logo_cream.png" alt="Analog Arcade" className="h-7 w-auto" />
            </Link>
            <p className="text-foreground/90 leading-relaxed font-sans text-sm">
              Defying Boring Since 1980. We create original tabletop games with arcade soul, premium components, and immersive worlds.
            </p>
          </div>

          {}
          <div className="lg:border-l lg:border-border/20 lg:pl-8">
            <h3 className="text-lg font-bold mb-6 font-serif tracking-widest text-foreground uppercase">Navigation</h3>
            <MenuProvider menu_id="51">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div className="lg:border-l lg:border-border/20 lg:pl-8">
            <h3 className="text-lg font-bold mb-6 font-serif tracking-widest text-foreground uppercase">The Vault / Resources</h3>
            <ul className="space-y-3">
              {services.map((service, i) => <li key={service.name} data-index={i}>
                  <Link to={service.path} className="text-foreground/80 hover:text-primary transition-colors font-sans uppercase text-sm tracking-wide">
                    {service.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="lg:border-l lg:border-border/20 lg:pl-8">
            <h3 className="text-lg font-bold mb-6 font-serif tracking-widest text-foreground uppercase">Customer Care</h3>
            <ul className="space-y-4">
              <li data-index={0}>
                <Link to="mailto:support@analogarcade.com" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors group">
                  <div className="p-2 rounded-md bg-muted group-hover:bg-primary/10 transition-colors border border-border">
                    <Mail className="size-4 text-foreground group-hover:text-primary" />
                  </div>
                  <span className="font-sans text-sm">support@analogarcade.com</span>
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/ContactPage" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors group">
                  <div className="p-2 rounded-md bg-muted group-hover:bg-primary/10 transition-colors border border-border">
                    <MessageCircle className="size-4 text-foreground group-hover:text-primary" />
                  </div>
                  <span className="font-sans text-sm">Retailer Inquiries</span>
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="lg:border-l lg:border-border/20 lg:pl-8">
            <h3 className="text-lg font-bold mb-6 font-serif tracking-widest text-foreground uppercase">Legal</h3>
            <ul className="space-y-3">
              {legalLinks.map((link, i) => <li key={link.name} data-index={i}>
                  <Link to={link.path} className="text-foreground/80 hover:text-primary transition-colors font-sans uppercase text-sm tracking-wide">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        {}
        <div className="border-t border-border pt-8 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-foreground/60 text-xs font-sans text-center md:text-left tracking-widest uppercase">
            VERSION 1.0 • MAY 2024 • &copy; {new Date().getFullYear()} Analog Arcade.
          </p>
          <div className="flex items-center gap-4">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.label} to={social.href} newTab aria-label={social.label} className="text-foreground/60 hover:text-primary transition-colors p-2" data-index={i}>
                  <Icon className="size-5" />
                </Link>;
          })}
          </div>
        </div>
        <div className="mt-8 text-center">
          <p className="text-[10px] font-serif tracking-[0.3em] text-foreground/40 uppercase">
            THANK YOU FOR HELPING US DEFY BORING
          </p>
        </div>
      </div>
    </section>;
}